import React from "react";

import {
    FormEnabler,
    ValidatedForm,
    MInput,
    MCheckbox
} from "components/forms";

import {
    payloadBuilder,
    invalidFieldsMapper,
    networkErrorHelper,
    notNullObjectBuilder,
    adminService,
} from "libs";

import {
    Card,
    CardBody,
} from 'design-react-kit';
import { MTextArea } from "../shared/MTextArea";

const FIELDS_GROUP = [
    [
        {
            id: "enrollEnabled",
            field: "enrollEnabled",
            label: "iscrizione abilitata",
            component: MCheckbox,
            className: "col-md-4"
        },    
        {
            id: "aa",
            field: "aa",
            label: "anno",
            component: MInput,
            type: "text",
            className: "col-md-4"
        },
        {
            field: "code",
            label: "codice",
            component: MInput,
            type: "text",
            className: "col-md-4"
        }
    ],          
    [
        {
            field: "title",
            label: "titolo",
            component: MInput,
            type: "text",
            className: "col-md-12"
        },
        {
            field: "subTitle",
            label: "sottotitolo",
            component: MInput,
            type: "text",
            className: "col-md-12"
        }
    ],
    [
        {
            field: "label",
            label: "descrizione",
            component: MTextArea,
            rows: 7,
            className: "col-md-12"
        }
    ],
    [
        {
            field: "summary",
            label: "Contenuto",
            component: MTextArea,
            rows: 7,
            className: "col-md-12"
        }
    ]
];

export class AdminCourseType extends ValidatedForm {

    ERROR_MESSAGES = {
        code: "Codice non valido",
        label: "Descrizione non valido",
        title: "Titolo non valido",
        subTitle: "Sottotitolo non valido",
    };

    emptyFields = {
        code: '',
        label: '',
        title: '',
        subTitle: '',
        aa: '',
        enrollEnabled: false,
        summary: ''
    };

    validation = {
        code: value => /^[a-z0-9]+$/i.test(value) && value !== null && value.length>1,
        label: value => /^[a-z0-9:'!?.,-/àèéì'òù,/\s"]+$/i.test(value) && value !== null,
        title: value => /^[a-z0-9:'!?.,-/àèéì'òù,/\s"]+$/i.test(value) && value !== null,
        //subTitle: value => /^[a-z0-9:'!?.,-/àèéì'òù,/\s"]+$/i.test(value) && value !== null,
        //summary: value => /^[a-z0-9:'!?.,-/àèéì'òù,/\s"]+$/i.test(value),
        aa: value => /^\d{4}$/i.test(value) && value !== null
    };

    //--- ---
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            ...this.emptyFields,
            defaultValues: { ...this.emptyFields },
            formActive: parseInt(this.props.idCourseType) > 0 ? false : true
        };

        // bind event handler to invoke it from child component
        this.onChange = this.onChange.bind(this);
    }

    loadRemote(additionalState = {}) {
        //--- prevent loadRemote when not required ---
        if (parseInt(this.props.idCourseType) <= 0) {
            return false;
        }

        let filter = {
            searchFilter:{
              id: parseInt(this.props.idCourseType)
            }
        }        

        adminService.courseType(filter)
            .then(({ data }) => {
                const defaultValues = notNullObjectBuilder(
                    this.emptyFields,
                    data.payload.courseTypes
                );
               
                const newState = {
                    defaultValues,
                    ...additionalState,
                    loading:false
                };

                this.setState(newState);
            })
            .catch(error => {
                networkErrorHelper.notify(error);
                console.log(error);
                this.setState({loading:false});
            });
    }

    onBackPage = () => {
        window.history.back();
    }

    saveRemote = () => {
        const payload = payloadBuilder(this.state);

        if (parseInt(this.props.idCourseType) > 0) {
            adminService.updateCourseType(payload).then(
                (result) => {
                    this.onBackPage();
                }
            )
            .catch(errors => {
                if (networkErrorHelper.is422(errors)) {
                    const newState = invalidFieldsMapper(
                        errors,
                        this.state,
                        this.ERROR_MESSAGES
                    );
                    this.setState({ ...newState });
                } else {
                    networkErrorHelper.notify(errors);
                }
            });

        } else {

            adminService.insertCourseType(payload).then(
                (result) => {
                    this.onBackPage();
                }
            )
            .catch(errors => {
                if (networkErrorHelper.is422(errors)) {
                    const newState = invalidFieldsMapper(
                        errors,
                        this.state,
                        this.ERROR_MESSAGES
                    );
                    this.setState({ ...newState });
                } else {
                    networkErrorHelper.notify(errors);
                }
            });
        }
    };

    render() {
        
        if (this.loading){
            return (<></>);
        }

        let { formActive, defaultValues } = this.state;

        if (parseInt(this.props.idCourse) === 0) {
            formActive = true;
        }

        const { formValid, code } = this.renderFields(FIELDS_GROUP, defaultValues, formActive);

        return (
            <>
                <Card tag="div" className="card-bg card-big rounded shadow border-bottom-card">
                    <div className="flag-icon" />
                    <CardBody tag="div">
                        <form className="user" id="courseform">
                            {code}
                        </form>

                        <div className="mt-4">
                            <FormEnabler
                                onSubmit={this.onSubmit}
                                onCancel={parseInt(this.props.idCourseType) > 0 ? this.onCancel : this.onBackPage}
                                onToggle={this.toggleForm}
                                isFormActive={formActive}
                                disableSave={!formValid}
                            />
                        </div>
                    </CardBody>
                </Card>               
            </>
        );
    }
}
